import styled from 'styled-components';

export const Link = styled.a`
  display: flex;
  align-items: center;
`;
